export const SET_APP_ERROR = "SET_APP_ERROR";

export const setAppError = (error) => ({ type: SET_APP_ERROR, payload: error });
